import React, { createContext, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();

  const login = (username, password) => {
    // MOCK: Simulating credential check
    if (username === 'client1' && password === 'password') {
      const user = { username, role: 'client', id: 'user_client1' };
      setCurrentUser(user);
      navigate('/client');
      return true;
    } else if (username === 'admin_user' && password === 'adminpass') {
      const user = { username, role: 'admin', id: 'user_admin1' };
      setCurrentUser(user);
      navigate('/admin');
      return true;
    }
    return false;
  };

  const logout = () => {
    setCurrentUser(null);
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ currentUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
